import { Styles, generateClasses } from 'netline-ui';
import getAppFrameTheme from 'utils/theme';

export const generalContentClasses = generateClasses('GeneralContent', [
  'root',
  'logoWrapper',
  'airlineLogo',
  'dialogContent',
  'dialogHeader',
  'dialogActions',
  'title',
  'titleText',
  'domainName',
  'environment',
  'actions',
  'tailLogo',
  'lsyLogo',
  'copyright',
] as const);

const styles: Styles = ({ theme, theme: { spacing, palette } }) => {
  const {
    aboutDialog: {
      airlineLogoHeight,
      lufthansaSystemsLogoHeight: lsyLogoHeight,
      tailLogoBottom,
      tailLogoRight,
      tailLogoHeight,
    },
  } = getAppFrameTheme(theme);

  return {
    [`&.${generalContentClasses.root}`]: {
      position: 'relative',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      backgroundImage: "url('./image/aboutDialogBackground.jpg')",
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    },
    [`.${generalContentClasses.titleText}`]: {
      flex: 1,
    },
    [`.${generalContentClasses.tailLogo}`]: {
      position: 'absolute',
      bottom: tailLogoBottom,
      right: tailLogoRight,
      height: tailLogoHeight,
      transform: 'scaleX(-1)',
      maxWidth: '50%',
    },

    [`.${generalContentClasses.domainName}`]: {
      marginLeft: spacing(2),
      color: palette.primary[900],
      wordSpacing: spacing(-0.5),
    },

    [`.${generalContentClasses.dialogContent}`]: {
      fontSize: 16,
      color: palette.grey[900],
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
    },
    [`.${generalContentClasses.dialogActions}`]: {
      justifyContent: 'flex-start',
    },

    [`.${generalContentClasses.logoWrapper}`]: {
      padding: spacing(1, 4, 2, 1),
    },

    [`.${generalContentClasses.airlineLogo}`]: {
      maxHeight: airlineLogoHeight,
    },

    [`.${generalContentClasses.dialogHeader}`]: {},

    [`.${generalContentClasses.title}`]: {
      fontFamily: 'LufthansaHeadWeb',
      fontWeight: 800,
      fontSize: 32,
      letterSpacing: 0.25,
      textAlign: 'left',
      color: palette.primary.pressed,
      marginRight: spacing(1),
    },

    [`.${generalContentClasses.environment}`]: {
      fontFamily: 'LufthansaHeadWeb',
      color: palette.grey[600],
    },

    [`.${generalContentClasses.actions}`]: {
      display: 'flex',
      margin: spacing(4, 0),
    },

    [`.${generalContentClasses.lsyLogo}`]: {
      height: lsyLogoHeight,
    },

    [`.${generalContentClasses.copyright}`]: {
      fontFamily: 'LufthansaTextWeb',
      fontSize: 12,
      fontWeight: 500,
      letterSpacing: 0.4,
      color: palette.grey[600],
    },
  };
};

export default styles;
